export {default as GetCategoryDetails} from './GetCategoryDetails';
export {default as GetProductDetails} from './GetProductDetails';
export {default as GetUserLogin} from './GetUserLogin';
export {default as GetOrderDetails} from './GetOrderDetails';
export {default as GetCustomerDetails} from './GetCustomerDetails';
export {default as GetPaymentDetails} from './GetPaymentDetails';
export {default as GetWalletDetails} from './GetWalletDetails';
export {default as GetTicketDetails} from './GetTicketDetails';












// WEBPACK FOOTER //
// ./src/components/services/index.js